// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3UpS7","file":"styles_file__1vyBe"};